import { defaultPeriodValue } from '@/react/edge/edge-stacks/components/RetryDeployPeriod';
import { getDefaultStaggerConfig } from '@/react/edge/edge-stacks/components/StaggerFieldset.types';
import {
  DeploymentType as EdgeStackDeploymentType,
  EdgeStack,
} from '@/react/edge/edge-stacks/types';

import { Workflow, WorkflowArtifact } from '../types';
import { Artifact, FormValues } from '../wizard/types';
import { DeploymentType } from '../wizard/detectDeploymentType';

export function toEditFormValues(
  workflow: Workflow,
  edgeStacks: Array<EdgeStack>
): FormValues {
  const artifacts = workflow.artifacts.map((artifact, index) =>
    toArtifactValues(artifact, edgeStacks[index])
  );
  const firstSourceId = artifacts[0]?.files[0]?.sourceId;

  return {
    name: workflow.name,
    sources: firstSourceId ? [firstSourceId] : [],
    artifacts,
  };
}

function toArtifactValues(
  artifact: WorkflowArtifact,
  edgeStack: EdgeStack
): Artifact {
  return {
    name: artifact.name,
    deploymentType: toWizardDeploymentType(edgeStack.DeploymentType),
    files: artifact.files.flatMap((file) =>
      file.sourceId
        ? [
            {
              sourceId: file.sourceId,
              path: file.path ?? '',
              ref: file.ref ?? '',
            },
          ]
        : []
    ),
    targets: artifact.target?.edgeGroupIds ?? [],
    config: {
      envVars: edgeStack.EnvVars ?? [],
      prePullImage: edgeStack.PrePullImage,
      retryDeploy: edgeStack.RetryPeriod > 0,
      retryPeriod:
        edgeStack.RetryPeriod > 0 ? edgeStack.RetryPeriod : defaultPeriodValue,
      parallelConfig: edgeStack.StaggerConfig ?? getDefaultStaggerConfig(),
      registryId: edgeStack.Registries?.[0],
      relativePath: {
        AlwaysCloneGitRepoForRelativePath:
          edgeStack.AlwaysCloneGitRepoForRelativePath,
        FilesystemPath: edgeStack.FilesystemPath,
        PerDeviceConfigsGroupMatchType:
          edgeStack.PerDeviceConfigsGroupMatchType,
        PerDeviceConfigsMatchType: edgeStack.PerDeviceConfigsMatchType,
        PerDeviceConfigsPath: edgeStack.PerDeviceConfigsPath,
        SupportPerDeviceConfigs: edgeStack.SupportPerDeviceConfigs,
        SupportRelativePath: edgeStack.SupportRelativePath,
      },
      useManifestNamespaces: edgeStack.UseManifestNamespaces,
    },
  };
}

function toWizardDeploymentType(
  deploymentType: EdgeStackDeploymentType
): DeploymentType {
  return deploymentType === EdgeStackDeploymentType.Compose
    ? DeploymentType.Compose
    : DeploymentType.Kubernetes;
}
